export const HEADER_CONTACT_US_TEST_ID = 'HEADER_CONTACT_US_TEST_ID';
export const HEADER_SERVICES_TEST_ID = 'HEADER_SERVICES_TEST_ID';
export const HEADER_HELP_TEST_ID = 'HEADER_HELP_TEST_ID';
export const HEADER_MY_LIST_TEST_ID = 'HEADER_MY_LIST_TEST_ID';
export const HEADER_LOGIN_TEST_ID = 'HEADER_LOGIN_TEST_ID';
export const HEADER_CASHBACK_TEST_ID = 'HEADER_CASHBACK_TEST_ID';

export const MOBILE_BURGER_MENU_TEST_ID = 'MOBILE_BURGER_MENU_TEST_ID';
